

function UserDetails() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Membership.UserHistory visual. <br/>
   /// <br/>
    /// Author: AFU<br />
    /// Date: 7.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
  	/// **********************************************************************<br />
    /// *** v1.0.1 (WMI) - 12.12.2018                                     ´  *<br />
    /// **********************************************************************<br />
    /// * - added tab for reports                                           *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 7.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.validation = null;
}
UserDetails.prototype = new vcTemplate();
UserDetails.prototype.init = function () {
    /// <summary>
    /// This function sets the input field values and inits the clickhandler and js-based input validation
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
        me.showInfo("", "", false);
        me.visual.find(".button-toggle").button();
        //inits the back button
        me.visual.find('.button-toggle').button().off('click').on("click", function () {
            me.selectDetails($(this));
        });
        me.selectDetails($(me.visual.find(".button-toggle")[0]));
        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};




UserDetails.prototype.selectDetails = function (obj) {
    /// <summary>
    /// This function sets the active detail menu point and loads the content for the detail <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //init list entry click handler
        me.visual.find('.button-toggle').removeClass("button-toggle-active");
        obj.addClass("button-toggle-active");
        me.loadDetails();
        return true;

    } catch (ex) { me.writeError('selectDetails', ex); return false; }
};

UserDetails.prototype.loadDetails = function () {
    /// <summary>
    /// This function loads the visuals based on the selected detail menu point <br/>

    /// </summary>
    var me = this;
    var type = "";
    try {
        if (me.error) { return false; }
        //init list entry click handler
        type = me.visual.find('.button-toggle-active').attr("data-type");
 
        me.visual.find("#divEdit").html(me.vcC.getLoadingIcon());
        switch (type) {
            case "profile":
                me.visual.find("#divEdit").html("<div id='divUserEdit' >" + me.vcC.getLoadingIcon() + "</div><div id='divUserSystemEdit' ></div>");
                me.vcVisual.addVisualBaseByName('divUserE', 'VISUAL_FORM_USER', 'dit', getCurrentTimestamp(), parseInt(me.visual.find("#divUserEdit").height(), 10), parseInt(me.visual.find("#divUserEdit").width(), 10)-40, 'true', me.uid, me.deviceType);
               
                if (me.uid !== me.myID) {
                    me.vcVisual.addVisualBaseByName('divUserSys','VISUAL_MEMBERSHIP_USER_INFORMATION','temEdit', getCurrentTimestamp(),parseInt(me.visual.find("#divUserSystemEdit").height(), 10),parseInt(me.visual.find("#divUserSystemEdit").width(), 10), JSON.stringify({ 'id': me.uid }),"",me.deviceType);
                } else {
                    me.hasNoRights(me.visual.find("#divUserSystemEdit"));
                }
                break;
            case "groups":
               
                me.visual.find("#divEdit").html("<div id='divGroupEdit' >" + me.vcC.getLoadingIcon() + "</div><div id='divMenuPreview' ></div>");
                me.visual.find("#divMenuPreview").width(parseInt(me.width - me.visual.find("#divGroupEdit").width() - 20, 10));
                if (me.uid !== me.myID) {
                me.vcVisual.addVisualBaseByName('divGroup', 'VISUAL_MEMBERSHIP_ASSIGNMENT_GROUP2USER', 'Edit', getCurrentTimestamp(), parseInt(me.visual.find("#divGroupEdit").height(), 10)-40, parseInt(me.visual.find("#divGroupEdit").width(), 10), JSON.stringify({ "AssID": me.uid }), '', me.deviceType);
                } else {
                    me.hasNoRights(me.visual.find("#divGroupEdit"));
                }
                me.vcVisual.addVisualBaseByName('divMenu', 'VISUAL_MEMBERSHIP_MENUPREVIEW', 'Preview', getCurrentTimestamp(), parseInt(me.visual.find("#divMenuPreview").height(), 10)-40, parseInt(me.visual.find("#divMenuPreview").width(), 10), JSON.stringify({ "id": me.uid }), '', me.deviceType);
              
                break;
            case "projects":
                if (me.uid !== me.myID) {
                me.vcVisual.addVisualBaseByName('divE', 'VISUAL_MEMBERSHIP_ASSIGNMENT_LOGGER2USER', 'dit', getCurrentTimestamp(), parseInt(me.visual.find("#divEdit").height(), 10)-40, parseInt(me.visual.find("#divEdit").width(), 10), JSON.stringify({ "AssID": me.uid }), '', me.deviceType);
                } else {
                    me.hasNoRights(me.visual.find("#divEdit"));
                }
                break;
               case "reports":
                if (me.uid !== me.myID) {
                me.vcVisual.addVisualBaseByName('divE', 'VISUAL_MEMBERSHIP_SINGLEUSER2REPORT', 'dit', getCurrentTimestamp(), parseInt(me.visual.find("#divEdit").height(), 10)-40, parseInt(me.visual.find("#divEdit").width(), 10), JSON.stringify({ "AssID": me.uid }), '', me.deviceType);
                } else {
                    me.hasNoRights(me.visual.find("#divEdit"));
                }
                break;

            case "brands":
                if (me.uid !== me.myID) {
                me.vcVisual.addVisualBaseByName('divE', 'VISUAL_MEMBERSHIP_ASSIGNMENT_CREDENTIALS2USER', 'dit', getCurrentTimestamp(), parseInt(me.visual.find("#divEdit").height(), 10)-40, parseInt(me.visual.find("#divEdit").width(), 10), JSON.stringify({ "AssID": me.uid }), '', me.deviceType);
                } else {
                    me.hasNoRights(me.visual.find("#divEdit"));
                }
                break;
            case "registration":
                me.vcVisual.addVisualBaseByName('divE', 'VISUAL_MEMBERSHIP_REGISTRATIONEMAIL', 'dit', getCurrentTimestamp(), parseInt(me.visual.find("#divEdit").height(), 10), parseInt(me.visual.find("#divEdit").width(), 10), JSON.stringify({ "ID": me.uid }), '', me.deviceType);
                break;
            case "history":
                me.vcVisual.addVisualBaseByName('divE', 'VISUAL_MEMBERSHIP_USERHISTORY', 'dit', getCurrentTimestamp(), parseInt(me.visual.find("#divEdit").height(), 10), parseInt(me.visual.find("#divEdit").width(), 10), JSON.stringify({ "ID": me.uid }), '', me.deviceType);
                break;
            case "delete":
                me.vcVisual.addVisualBaseByName('divE', 'VISUAL_MEMBERSHIP_USERDELETION', 'dit', getCurrentTimestamp(), parseInt(me.visual.find("#divEdit").height(), 10), parseInt(me.visual.find("#divEdit").width(), 10), JSON.stringify({ "ID": me.uid }), '', me.deviceType);
                break;
            default:
                me.visual.find("#divEdit").html("");
                break;
        }


        return true;

    } catch (ex) { me.writeError('loadDetails', ex); return false; }
};


UserDetails.prototype.hasNoRights = function (obj) {
    /// <summary>
    /// This function shows an error message if the user has no rights to change its own settings.
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }
        obj.html("<div class='error noRights'>" + me.resources.noRights + "</div>");
        return true;
    } catch (ex) { me.writeError('hasNoRights', ex); return false; }


};

UserDetails.prototype.doEvent = function (event) {
    /// <summary>
    /// This function handles the VCMQ events.
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }
        switch (event.msg) {
            //reloads the menu preview when the membership assignment has been changed
            case 'MS_ASSIGNMENT_RIGHTSGROUPS_UPDATE':
                me.vcVisual.addVisualBaseByName('divMenu', 'VISUAL_MEMBERSHIP_MENUPREVIEW', 'Preview', getCurrentTimestamp(), parseInt(me.visual.find("#divMenuPreview").height(), 10), parseInt(me.visual.find("#divMenuPreview").width(), 10), JSON.stringify({ "id": me.uid }), '', me.deviceType);
                ; break;
        }
        return true;
    } catch (ex) { me.writeError('doEvent', ex); return false; }


};

